import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { hideConfirm } from '@jetbrains/ring-ui/components/confirm-service/confirm-service';
import trashIcon from '@jetbrains/icons/trash';
import confirmUserActiveStatusChange from '@modules/users/user-operations/confirm-user-active-status-change';
import { useActiveStatusUserMutation } from '@common/queries/users';
import { TableActionButton } from '@common/tables/table-action-button';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
export function UsersTableActions({ id, isActive, username, version }) {
    const mutation = useActiveStatusUserMutation();
    const serverConfig = useServerConfigContext();
    const hasIdp = serverConfig.hasIdpIntegration();
    const onDisableUser = useCallback((userId) => {
        mutation.mutate({
            id: userId,
            version,
            isActive: false
        });
    }, [mutation, version]);
    return (_jsx(TableActionButton, { title: hasIdp
            ? 'The users are managed in IDP. To deactivate user go to you Identity Provider'
            : 'Deactivate user', disabled: !isActive || hasIdp, icon: trashIcon, danger: true, action: () => confirmUserActiveStatusChange(username)
            .then(() => onDisableUser(id))
            .catch(hideConfirm) }));
}
